export interface ElementCardsFilterOptions {
  input: HTMLInputElement
  container: HTMLElement
  emptyMessage?: HTMLElement | null
  cardSelector?: string
  ignoreSelector?: string
}

const normalise = (text: string) => text.replace(/\s+/g, ' ').trim().toLowerCase()

// Text nodes are joined with spaces so that adjacent fields in the compact markup Slim emits
// stay separate words: a title "Banner foot" followed by the value "12" must not read as
// "foot12". textContent loses that boundary and innerText is not implemented in jsdom.
// Text inside `ignoreSelector` (column labels, the "Part of:" caption prefix) is skipped so the
// search matches values only, the way DataTables searches cells but not headers.
const searchableText = (element: HTMLElement, ignoreSelector: string) => {
  const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT, {
    acceptNode: (node) => (
      node.parentElement?.closest(ignoreSelector) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT
    ),
  })
  const parts: string[] = []
  while (walker.nextNode()) parts.push(walker.currentNode.nodeValue || '')
  return normalise(parts.join(' '))
}

export default function initElementCardsFilter({
  input,
  container,
  emptyMessage = null,
  cardSelector = '.element-card',
  ignoreSelector = '.element-card-label',
}: ElementCardsFilterOptions) {
  const apply = () => {
    // An empty query yields no tokens, and `every` on an empty array is true, so every card matches.
    const tokens = normalise(input.value).split(' ').filter(Boolean)
    let visible = 0

    container.querySelectorAll<HTMLElement>(cardSelector).forEach((card) => {
      const text = searchableText(card, ignoreSelector)
      const matches = tokens.every((token) => text.includes(token))
      card.hidden = !matches
      if (matches) visible += 1
    })

    if (emptyMessage) emptyMessage.hidden = visible > 0
  }

  input.addEventListener('input', apply)
  apply()

  return { apply }
}
